import { getJwt } from '@util'
import sha1 from 'sha1'
/**
 * @description:调用架构组方法时需增加sha1签名请求
 * @param {*} type 参数类型
 * @param {*} url 路径地址
 * @param {*} data 传递的参数
 * @return {*}
 */
export const requestHeader = (type, url, data) => {
  const clientId = '1JvxqWBVjfwRObeQDXycpKANi9PZGFtU'
  const SHARED_SECRET = '6Zec0lrmPSG3IX1sORhFykKwuHEDoTnx'
  const timestamp = Date.parse(new Date())
    .toString()
    .substr(0, 10) // 时间戳精确到秒
  let str =
    type +
    url +
    (type === 'GET' ? constgetparam(data) : JSON.stringify(data)) +
    clientId + //clientId
    SHARED_SECRET + //SHARED_SECRET
    timestamp //时间戳
  const sha1Str = 'HUNLIJI ' + sha1(str) + ':' + clientId
  return {
    Authorization: sha1Str, // sha1签名
    timestamp: timestamp, // 时间戳
    appName: 'localMerchantWeb',
    Auth: getJwt(), // 目前增加请求头效果为覆盖，需要增加需要的请求参数
    'Content-Type': 'application/json'
  }
}

/**
 * @description: 将数据转换为get请求格式
 * @param {object} obj 主要转换的入参对象
 * @return {string} 转换后的字符串
 */
export const constgetparam = obj => {
  let str = '?'
  for (let key in obj) {
    if (
      obj.hasOwnProperty(key) &&
      (obj[key] == null || obj[key] == undefined || obj[key] === '')
    ) {
    } else {
      str += key + '=' + obj[key] + '&'
    }
  }
  str = str.substr(0, str.length - 1)
  // get请求中文对验签生成的会有影响，做一次转码
  return encodeURI(str)
}
